import axios from "axios";

import variables from "@/global/variables";
import session, { Bidder } from "@/global/session";

/*
 * Client for the PHP OTP endpoints (otp-request.php / otp-verify.php). On a
 * successful verify it stores the signed session token via the session helper.
 */

export interface OtpRequestResult {
	ok: boolean;
	reason?: string;
	retryAfter?: number;
	// Present only in non-production so the login flow can be exercised locally.
	devCode?: string;
}

export interface OtpVerifyResult {
	ok: boolean;
	reason?: string;
	retryAfter?: number;
	token?: string;
	bidder?: Bidder;
}

export default class OtpSessionModel {
	static async request(phone: string): Promise<OtpRequestResult> {
		try {
			const response = await axios.post(variables.apiEndpoint + "/otp-request.php", { phone });
			return response.data as OtpRequestResult;
		} catch (error) {
			if (error.response && error.response.data) return error.response.data as OtpRequestResult;
			throw error;
		}
	}

	static async verify(phone: string, code: string): Promise<OtpVerifyResult> {
		let data: OtpVerifyResult;

		try {
			const response = await axios.post(variables.apiEndpoint + "/otp-verify.php", { phone, code });
			data = response.data as OtpVerifyResult;
		} catch (error) {
			if (error.response && error.response.data) return error.response.data as OtpVerifyResult;
			throw error;
		}

		if (data.ok && data.token && data.bidder) {
			session.set(data.token, data.bidder);
		}

		return data;
	}
}
